import script from "./AddZc.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddZc.vue?vue&type=script&lang=ts&setup=true"

import "./AddZc.vue?vue&type=style&index=0&id=632b32c3&lang=scss&scoped=true"

import exportComponent from "E:\\svn\\xmTask(国振资产管理)1\\views\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-632b32c3"]])

export default __exports__